/**
 * 模块 - 采购管理 - 英文
 */
export default {
  purchasing: {
    creditOrderTitle: 'Credit Order',
    creditOrderHelpIntro: 'To help dealers develop rapidly',
    creditOrderReqTitle: '1. Order Requirements',
    creditOrderReqDesc: 'Dealers can submit credit orders to upstream agents',
    creditOrderFlowTitle: '2. Order Process',
    creditOrderFlowDesc1: 'Order takes effect after agent approval',
    creditOrderFlowDesc2: 'After agent ships, SN transfers to dealer',
    addPurchase: 'Add Purchase',
    initialPurchase: 'Initial Purchase',
    payment: 'Payment',
    invoiceConfirm: 'Invoice Confirmation',
    changeAddress: 'Change Address',
    receiptConfirm: 'Receipt Confirmation',
    deliveryConfirm: 'Delivery Order Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    invoiceConfirmTitle: 'Confirm that you have received the formal invoice for the order amount?',
    cancelOrderTip: 'Confirm to cancel the order? Once cancelled, paid amounts will be refunded to the agent account and corresponding futures order quota will be adjusted!',
    orderNo: 'Order No',
    orderTime: 'Order Time',
    buyNum: 'Quantity',
    orderAmount: 'Order Amount',
    receivedAmount: 'Received Amount',
    received: 'Received',
    snMatch: 'Device SN matches system',
    bothConfirm: '* Both must be confirmed',
    changeOrderAddress: 'Change Order Delivery Address',
    receiver: 'Receiver',
    receiverPhone: 'Receiver Phone',
    provinceCity: 'Province/City/District',
    agentWarehouse: 'Agent Warehouse',
    address: 'Address',
    pleaseFillReceiver: 'Enter receiver name',
    pleaseEnterReceiverPhone: 'Enter receiver phone',
    pleaseSelectProvince: 'Select province/city/district',
    pleaseSelectWarehouse: 'Select agent warehouse',
    pleaseSelectAddress: 'Select address',
    pleaseEnterRemark: 'Enter remark (max 200 chars)',
    productName: 'Product Name',
    discountAmount: 'Discount',
    freightAmount: 'Prepaid Freight',
    payStatus: 'Payment Status',
    orderStatus: 'Order Status',
    productionStatus: 'Production Status',
    remark: 'Remark',
    pleaseSelectProductionStatus: 'Select production status',
    receiverMobile: 'Receiver Mobile',
    dispatchNum: 'Dispatch Qty',
    dispatchType: 'Dispatch Type',
    regionCampusId: 'Region Agent ID',
    regionCampusName: 'Region Agent Name',
    orderType: 'Order Type',
    purchaseType: 'Purchase Type',
    lastPayTime: 'Last Pay Time',
    to: 'to',
    submitter: 'Submitter',
    submitTime: 'Submit Time',
    confirmTime: 'Confirm Time',
    confirmBy: 'Confirmed By',
    creator: 'Creator',
    pleaseEnterOrderNo: 'Enter order no',
    pleaseSelectPerson: 'Select person',
    pleaseSelectPayStatus: 'Select payment status',
    pleaseEnterProductName: 'Enter product name',
    pleaseSelectOrderStatus: 'Select order status',
    pleaseSelectOrderType: 'Select order type',
    pleaseSelectPurchaseTypeLabel: 'Select purchase type',
    pleaseSelectDispatchType: 'Select dispatch type',
    receiverInfo: 'Receiver Info',
    pleaseEnterReceiverQuery: 'Enter receiver name or phone',
    invoiceType: 'Select invoice type',
    invoiced: 'Invoiced',
    notInvoiced: 'Not Invoiced',
    pleaseFillValidPhone: 'Enter valid phone number',
    pleaseSelectProvinceCity: 'Select province/city/district',
    pleaseSelectAgentWarehouse: 'Select agent warehouse',
    pleaseFillAddress: 'Enter delivery address',
    // Secondment Goods
    secondmentGoods: 'Secondment Goods',
    addRegionPurchase: 'Region Purchase',
    deductionPay: 'Deduction Pay',
    applicationNo: 'Application No.',
    applicantAgentId: 'Applicant Agent ID',
    applicantAgentName: 'Applicant Agent Name',
    totalAmount: 'Total Amount',
    voucherDeductionAmount: 'Voucher Deduction Amount',
    remainingAmount: 'Remaining Amount',
    transferNum: 'Transfer Qty',
    detail: 'Detail',
    confirmResult: 'Confirm Result',
    agree: 'Agree',
    reject: 'Reject',
    confirmRemark: 'Confirm Remark',
    pleaseFillConfirmRemark: 'Please fill in confirm remark',
    confirmPaymentReceivedTip: 'Please confirm the other party has received payment before clicking Agree!!!',
    confirmCancelTip: 'Confirm to cancel?',
    voucherAccount: 'Voucher Account',
    accountBalance: 'Account Balance',
    pleaseEnterContent: 'Enter content',
    maxDeductible: 'Max deductible',
    yuan: 'CNY',
    pleaseSelectConfirmResult: 'Please select confirm result',
    paymentSuccess: 'Payment successful',
    orderWithRightsCannotEdit: 'This order uses rights and cannot be modified. You may cancel the order and place a new one.',
    orderWithVoucherCannotCancel: 'This order has delivery vouchers and cannot be cancelled',
    receivedAmountMinTip: 'Received amount must be >= 30% of order amount to submit',
    paySuccess: 'Payment Success',
    payFail: 'Payment Failed',
    distributeSuccess: 'Distributed successfully',
    confirmSuccess: 'Confirmed successfully',
    confirmFail: 'Confirm failed',
    cancelSuccess: 'Cancelled successfully',
    cancelFail: 'Cancel failed',
    modifySuccess: 'Modified successfully',
    modifyFail: 'Modify failed',
    paymentFail: 'Payment failed',
    // Credit Orders
    creditOrders: 'Credit Orders',
    creditOrderHelpTitle: 'To help dealers grow quickly',
    creditOrderHelpOrderReq: 'Order Requirements',
    creditOrderHelpOrderReqDesc: 'Dealers can submit credit orders to upper-level agents',
    creditOrderHelpOrderFlow: 'Order Process',
    creditOrderHelpOrderFlowDesc1: 'Orders take effect after agent approval',
    creditOrderHelpOrderFlowDesc2: 'After agent ships, SN transfers to dealer',
    addCreditOrder: 'Add Credit Order',
    creditOrderNo: 'Credit Order No.',
    orderCreateTip: 'Orders can be unpaid or partially paid after creation. See details: ',
    viewDetail: 'View Details',
    provinceAudit: 'Province Audit',
    auditResult: 'Audit Result',
    auditRemark: 'Audit Remark',
    creditOrderConfirmTip: 'Please confirm the other party has received goods on credit and paid after selling the devices!!!',
    exemptionPay: 'Exemption Pay',
    paymentDeductionTip: 'This payment will deduct:',
    promotionFeeAccount: 'Promotion Fee Account',
    voucherBonusAccount: 'Voucher Bonus Account',
    cashAccount: 'Cash Account',
    goldAccount: 'Gold Account',
    deliveryVoucherAccount: 'Delivery Voucher Account',
    pleaseConfirmReceipt: 'Please confirm receipt',
    pleaseConfirmSnMatch: 'Please confirm device SN matches system',
    // Double Order
    doubleOrder: 'Double Order',
    addDoubleOrder: 'Add Double Order',
    sendDeliveryVoucher: 'Send Delivery Voucher',
    distributeVoucherTip: 'Once delivery vouchers are issued in advance, this double order cannot be modified. Confirm to issue?',
    gotIt: 'Got it',
    paySuccessAmount: 'Successfully paid ¥{money}',
    payFailAmount: 'Failed to pay ¥{money}',
    createTime: 'Create Time',
    orderNoSearch: 'Order No',
    pleaseEnterOrderNoSearch: 'Enter order no',
    agent: 'Agent',
    pleaseSelectAgent: 'Select agent',
    regionAgent: 'Region Agent',
    pleaseSelectRegionAgent: 'Select region agent',
    status: 'Status',
    pleaseSelectStatus: 'Select status',
    isVoucher: 'Voucher Deduction',
    yes: 'Yes',
    no: 'No',
    pleaseSelectExemptionPay: 'Select exemption pay',
    relatedAgentId: 'Related Agent ID',
    relatedAgent: 'Related Agent',
    relatedAgentName: 'Related Agent Name',
    pleaseSelectRelatedAgent: 'Select related agent',
    actualPayAmount: 'Actual Pay Amount',
    // Purchase creation/detail pages
    purchaseUnit: 'Purchase Unit',
    pleaseEnterReceiver: 'Enter receiver name',
    phoneRequired: 'Phone number is required',
    pleaseSelectDispatch: 'Select dispatch method',
    pleaseEnterAddress: 'Enter delivery address',
    pleaseEnterWarehouse: 'Enter agent warehouse',
    selectAddGoods: '+ Select Add Goods',
    goodsDetail: 'Goods Detail',
    selectDiscount: '+ Select Discount',
    selectDiscountTitle: 'Select Discount',
    discountInfo: 'Discount Info',
    selectedVouchersAvailable: 'Selected {selected}/{total} available',
    vouchersAvailable: '{total} available',
    logisticsDetail: 'Logistics Detail',
    productDetail: 'Product Detail',
    sequenceNo: 'No.',
    orderProduct: 'Order Product',
    orderPendingSendNum: 'Order Pending Send Qty',
    allocationDetailTable: 'Allocation Detail Table',
    orderProductQty: 'Order Product Qty',
    statisticsTime: 'Statistics Time',
    totalLabel: 'Total',
    deliveryQty: 'Delivery Qty',
    creditOrderInterestTip: 'Your credit order has an interest differential. Please pay the differential amount of {amount} yuan for this order to proceed to the next review stage.',
    paymentDetail: 'Payment Detail',
    freightDetail: 'Prepaid Freight Detail',
    auditDetail: 'Audit Detail',
    priorityPurchaseRight: 'Enjoy "Priority Purchase for Limited Models" right',
    discountRightRight: 'Enjoy "Purchase Price Discount" right',
    originalPriceTotal: 'Original Total',
    saveAndPay: 'Save & Pay',
    addGoods: 'Add Goods',
    inventoryStatusReminder: 'Inventory Status Reminder',
    inventoryStatusTip: 'The inventory status of selected goods is',
    inventoryStatusTip2: '. Delivery may take longer. You can go back to reselect other goods, or continue and wait for delivery.',
    presale: 'Presale',
    outOfStock: 'Out of Stock',
    lowStock: 'Low Stock',
    continueOrder: 'Continue Order',
    reselectGoods: 'Reselect Goods',
    customDiscountAmount: 'Custom Discount Amount',
    pleaseEnterCustomDiscount: 'Enter custom discount amount',
    headquartersDeliveryTip: 'Prototypes, subscription cards, accessories - please select [HQ Delivery]',
    changeToHeadquartersDelivery: 'Change dispatch method to [HQ Delivery]?',
    regionDeliveryTip: 'Learning machines, smart pens - please select [Region Agent Delivery]',
    changeToRegionDelivery: 'Change dispatch method to [Region Agent Delivery]?',
    limitedModelTip: 'This limited model requires [HQ Delivery]',
    confirmDelete: 'Confirm to delete?',
    pleaseEnterCampusAddress: 'Enter campus address',
    applicantAgent: 'Applicant Agent',
    deliveryRegionAgent: 'Delivery Region Agent',
    selectDeliveryRegionAgent: 'Delivery Region Agent',
    pleaseSelectDeliveryRegionAgent: 'Select delivery region agent',
    isDoubleOrder: 'Double Order',
    pleaseEnterAgentFilter: 'Enter agent ID or name to filter',
    payAmount: 'Pay Amount',
    operator: 'Operator',
    dispatchDate: 'Dispatch Date',
    expressCompany: 'Express Company',
    expressNo: 'Express No.',
    logisticsStatus: 'Logistics Status',
    dispatchQty: 'Dispatch Qty',
    chargeItem: 'Charge Item',
    unitPrice: 'Unit Price',
    quantity: 'Quantity',
    amount: 'Amount',
    rightName: 'Right Name',
    applicableProduct: 'Applicable Product',
    expiryTime: 'Expiry Time',
    rightCode: 'Right Code',
    paySerialNo: 'Pay Serial No.',
    payMethod: 'Pay Method',
    payTime: 'Pay Time',
    auditTime: 'Audit Time',
    auditByName: 'Auditor',
    auditByCampusId: 'Auditor Agent ID',
    auditByCampusName: 'Auditor Agent Name',
    auditStatusStr: 'Audit Result',
    pleaseSelectDeliveryRegionAgentRule: 'Please select delivery region agent',
    // Product selection modal
    productManual: 'Product Manual',
    inventory: 'Inventory',
    view: 'View',
    suggestedRetailPrice: 'Suggested retail price: ¥{price}',
    // Purchase modals
    discount: 'Discount',
    purchaseNo: 'Purchase No.',
    purchaseUnit: 'Purchase Unit',
    creator: 'Creator',
    receiver: 'Receiver',
    receiverAddress: 'Delivery Address',
    receiverPhone: 'Receiver Phone',
    remark: 'Remark',
    serialNo: 'No.',
    unitPrice: 'Unit Price (CNY)',
    unitPricePlain: 'Unit Price',
    quantity: 'Qty (units)',
    quantityPlain: 'Quantity',
    customDiscount: 'Custom Discount',
    originalTotal: 'Original Total',
    discountAmountLabel: 'Discount Amount',
    purchaseAmount: 'Purchase Amount',
    cancel: 'Cancel',
    save: 'Save',
    saveSuccess: 'Saved successfully',
    saveFail: 'Save failed',
    performanceSplit: 'Performance Split',
    orderQty: 'Order Qty',
    orderAmount: 'Order Amount',
    cashAmount: 'Cash Amount',
    contractManager: 'Contract Manager',
    tmkStaff: 'TMK Staff',
    add: '+ Add',
    splitPerson: 'Split Person',
    pleaseSelectPerson: 'Select person',
    filterKeyword: 'Enter keyword to filter',
    splitRatio: 'Split Ratio',
    splitAmount: 'Split Amount',
    delete: 'Delete',
    splitRatioTotal: 'Split Ratio Total',
    splitAmountTotal: 'Split Amount Total',
    fillCompleteTip: 'Please complete row {index}',
    splitSuccess: 'Split successful!',
    splitFail: 'Split failed!',
    returnFreight: 'Refund Freight',
    returnGoods: 'Return Goods',
    payment: 'Payment',
    orderTime: 'Order Time',
    purchaseOrderNo: 'Purchase No.',
    purchaseQuantity: 'Purchase Quantity',
    actualPaymentAmount: 'Actual Payment Amount',
    shippingPlan: 'Shipping Plan',
    plan1: 'Plan 1',
    plan2: 'Plan 2',
    freightCollect: 'Freight Collect',
    freightCollectTip: 'Pay upon delivery',
    prepaidFreight: 'Prepaid Freight',
    freightPrepay: 'Freight Prepay',
    prepaidFreightTip: 'Pay when placing order',
    freightCollectTipLong: 'Pay to the courier after delivery. Actual amount may vary by about 20%, subject to actual charge',
    prepaidFreightTipLong: 'Paid together with the order amount. Any dispute will be handled by headquarters',
    purchaseFeeNoticeTitle: 'This order has less than 10 units. By courier policy it should be freight collect; to let you enjoy shipping discounts, we provide prepaid collect-freight service. Please note:',
    purchaseFeeRule1: '1. Freight-collect discount is based on the discount signed between the company and JD warehouse. Current discount is 35% off (pay 65%); any changes will be notified in time;',
    purchaseFeeRule2: '2. Prepaid collect-freight is optional. If you give up the discount from prepaying freight, you must pay collect freight to the courier company upon receipt; actual amount and method are subject to courier company;',
    purchaseFeeRule3: '3. After prepaid collect-freight is charged, if this order is merged with other orders and meets free-shipping conditions (quantity >= 10), the prepaid freight will be automatically refunded after completion;',
    originalPrice: 'Original Price',
    purchaseQty: 'Purchase Qty',
    units: ' units',
    unitPiece: ' piece(s)',
    paidAmount: 'Paid Amount',
    freightIncluded: 'Freight Included',
    procurementAgentBalance: 'Procurement Agent Balance',
    relatedAgentAccountBalance: 'Related Agent Account Balance',
    promoteAccount: 'Promotion Account',
    paymentMethod: 'Payment Method',
    pleaseSelectPaymentMethod: 'Please select a payment method below',
    corporateTransfer: 'Bank transfer',
    pay: 'Pay',
    voucherBonusAccount: 'Voucher Bonus Account',
    cashAccount: 'Cash Account',
    accountBalance: 'Account Balance',
    availableAmount: 'Available Amount',
    otherAmount: 'Other Amount',
    paymentTitle: 'Procurement Payment',
    interestSpreadAmount: 'Interest Spread Amount',
    voucherCashNotZero: 'Voucher and cash account amounts cannot both be 0. Please modify!',
    paySuccess: 'Payment successful',
    payFail: 'Payment failed',
    drawInvoice: 'Draw Invoice',
    invoiceType: 'Invoice Type',
    pleaseSelectInvoiceType: 'Select invoice type',
    sendEmail: 'Send Email',
    pleaseEnterEmail: 'Enter email',
    invalidEmailFormat: 'Invalid email format!',
    deviceAmount: 'Device Amount',
    pleaseEnterDeviceAmount: 'Enter device amount',
    softwareAmount: 'Software Amount',
    pleaseEnterSoftwareAmount: 'Enter software amount',
    invalidNumberFormat: 'Invalid format. Enter a number!',
    amountNotNegative: 'Amount cannot be negative',
    recalcAmount: 'Recalculate Amount',
    total: 'Total: ',
    invoiceSuccess: 'Invoice created successfully',
    invoiceFail: 'Invoice creation failed',
    fillError: 'Fill error',
    batchImport: 'Batch Import',
    uploadDoc: 'Upload Document',
    dataValidate: 'Data Validation',
    importData: 'Import Data',
    complete: 'Complete',
    batchImportTip1: '1. Do not change header names or purchase order info in template',
    batchImportTip2: '2. For multiple devices per order, copy order info with one row per device',
    batchImportTip3: '3. Purchase order ID and number are unique identifiers',
    batchImportTip4: '4. Do not exceed 1000 rows in import file',
    selectImportFile: 'Select file and start import',
    dragOrClick: 'Drag file here or ',
    clickUpload: 'click to upload',
    dataValidating: 'Validating data, please wait',
    dataValidateComplete: 'Validation complete. Total ',
    orderInfo: ' order records',
    errorCount: 'Error count: ',
    fixAndRetry: '. Please fix and retry',
    errorDetailDownload: 'Error details.xls',
    errorDetailDownloadTip: 'Download table for error details',
    importing: 'Importing. You may close this page; the system will complete the import.',
    importComplete: 'Import complete. Click to view ',
    importDetail: 'Import details',
    upload: 'Upload',
    confirmImport: 'Confirm Import',
    onlyXlsFormat: 'Only .xls format is supported',
    noValidData: 'No valid data to import',
    warningDataError: 'Warning: Data errors remain',
    partialErrorImport: 'Some data has errors. If you confirm import, error rows will not be imported',
    submitSuccess: 'Submitted successfully',
    submitFail: 'Submit failed',
    pleaseSelectAgentWarehouseAddr: 'Please select agent warehouse',
    pleaseSelectDeliveryAddress: 'Please select delivery address',
    deleteSuccess: 'Deleted successfully!',
    pleaseSelectGoodsFirst: 'Please select goods first',
    pleaseEnterValidPhoneNum: 'Please enter a valid phone number',
    pleaseEnterDetailAddress: 'Please enter detailed delivery address, e.g. Province City District Street No.',
    pleaseAddGoodsQty: 'Please add goods quantity',
    pleaseSelectPurchaseType: 'Please select purchase type first',
    provinceAgentNoCredit: 'Province agents cannot use credit. Please use online orders!',
    notSameEntityNoCredit: 'You and the delivery agent are not the same entity. Please use online orders!',
    referralRewardStageNoCredit: 'You are in referral reward stage. Please use online orders!',
    onlyDealerCredit: 'Only dealers can apply for credit. Please use online orders!',
    queryFail: 'Query failed',
    saveSuccessExclamation: 'Saved successfully!',
    saveCancelled: 'Save cancelled',
    // Purchase order search/table
    purchaseNoLabel: 'Order No.:',
    pleaseEnterPurchaseNo: 'Enter order no.',
    agentLabel: 'Agent:',
    orderStatusLabel: 'Order Status:',
    pleaseSelectOrderStatus: 'Select order status',
    payStatusLabel: 'Payment Status:',
    pleaseSelectPayStatus: 'Select payment status',
    orderTimeLabel: 'Order Date',
    lastPayTimeLabel: 'Last Pay Time',
    productNameLabel: 'Product Name:',
    pleaseEnterProductName: 'Enter product name',
    purchaseQtyLabel: 'Purchase Qty:',
    purchaseAmountLabel: 'Purchase Amount:',
    paidAmountLabel: 'Paid Amount:',
    submitterLabel: 'Submitter:',
    pleaseSelectSubmitter: 'Select submitter',
    orderTypeLabel: 'Order Type:',
    pleaseSelectOrderType: 'Select order type',
    submitTimeLabel: 'Submit Time',
    receiverInfoLabel: 'Receiver Info:',
    pleaseEnterReceiverQuery: 'Enter receiver name or phone',
    isSplitLabel: 'Performance Assigned:',
    pleaseSelectIsSplit: 'Select if performance assigned',
    dispatchTypeLabel: 'Dispatch Type:',
    pleaseSelectDispatchType: 'Select dispatch type',
    remarkLabel: 'Remark:',
    remarkPlaceholder: 'Enter remark',
    isInvoiceLabel: 'Invoiced:',
    pleaseSelectInvoice: 'Select if invoiced',
    productTypeLabel: 'Product Type',
    pleaseSelectProductType: 'Select product type',
    contractAgentLabel: 'Contract Agent:',
    tmallOrderNoLabel: 'Tmall Order No.:',
    pleaseEnterTmallOrderNo: 'Enter Tmall order no.',
    agentWarehouseLabel: 'Agent Warehouse:',
    pleaseEnterAgentWarehouse: 'Enter agent warehouse',
    isDualOrderLabel: 'Dual Order:',
    pleaseSelectIsDualOrder: 'Select if dual order',
    relatedAgentLabel: 'Related Agent:',
    pleaseSelectRelatedAgent: 'Select related agent',
    campusId: 'Agent ID',
    campusName: 'Agent Name',
    receiveNum: 'Dispatch Qty',
    regionCampusIdLabel: 'Region Agent ID',
    regionCampusNameLabel: 'Region Agent Name',
    tmallOrderNoCol: 'Tmall Order No.',
    agentWarehouseNameCol: 'Agent Warehouse',
    dualCampusIdLabel: 'Related Agent ID',
    dualCampusNameLabel: 'Related Agent Name',
    submitterName: 'Submitter',

    // AgencyHierarchyMaintenance
    addHierarchyRelation: '+ Add Hierarchy Relation',
    editHierarchyRelation: 'Edit Hierarchy Relation',
    superiorAgent: 'Superior Agent',
    subordinateAgent: 'Subordinate Agent',
    pleaseSelectSuperiorAgent: 'Select superior agent',
    pleaseSelectSubordinateAgent: 'Select subordinate agent',
    isSendGood: 'Is Send Good',
    pleaseSelectIsSendGood: 'Select whether to send',
    subAgentRegion: 'Sub Agent Region',
    superiorAgentId: 'Superior Agent ID',
    superiorAgentName: 'Superior Agent Name',
    agentType: 'Agent Type',
    subordinateAgentId: 'Subordinate Agent ID',
    subordinateAgentName: 'Subordinate Agent Name',
    tip: 'Tip',
    editSuccess: 'Edit success',
    editFail: 'Edit failed',
    deleteOrderConfirmTip: 'Confirm to cancel order? Once cancelled, paid amount will be refunded, agent account will be adjusted and futures order quota will be updated!',
    saveSuccess: 'Save success',
    saveFail: 'Save failed',
    deleteSuccess: 'Delete success',
    deleteFail: 'Delete failed',
    hierarchyYes: 'Yes',
    hierarchyNo: 'No',

    // InAndOut
    outboundRecordImport: 'Outbound Record Import',
    stockOutDetail: 'Stock Out Detail',
    stockInRecord: 'Stock In Record',
    snCodeUpload: 'SN Code Upload',
    confirmCancelStockOut: 'Confirm cancel stock out?',
    stockOutWarehouse: 'Stock Out Warehouse',
    pleaseSelectStockOutWarehouse: 'Select stock out warehouse',
    stockOutType: 'Stock Out Type',
    pleaseSelectStockOutType: 'Select stock out type',
    stockOutTime: 'Stock Out Time',
    operationTime: 'Operation Time',
    logisticsNoLabel: 'Logistics No.',
    pleaseEnterLogisticsNo: 'Enter logistics no.',
    relatedOrderNo: 'Related Order No.',
    pleaseEnterRelatedOrderNo: 'Enter related order no.',
    agentId: 'Agent ID',
    agentName: 'Agent Name',
    deviceSN: 'Device SN',
    logisticsCompany: 'Logistics Method',
    operator: 'Operator',
    invalid: 'Invalid',
    valid: 'Valid',
    stockInNo: 'Stock In No.',
    pleaseEnterStockInNo: 'Enter stock in no.',
    stockInWarehouse: 'Stock In Warehouse',
    pleaseSelectStockInWarehouse: 'Select stock in warehouse',
    stockInType: 'Stock In Type',
    pleaseSelectStockInType: 'Select stock in type',
    stockInTime: 'Stock In Time',
    stockInStatus: 'Stock In Status',
    pleaseSelectStockInStatus: 'Select stock in status',
    creator: 'Creator',
    stockInNum: 'Stock In Qty',
    actualStockInNum: 'Actual Stock In Qty',
    stockInProduct: 'Stock In Product',
    pleaseSelectStockInProduct: 'Select stock in product',
    pleaseEnterStockInNum: 'Enter stock in qty',
    pleaseEnterRemark200: 'Enter remark, max 200 characters',
    pleaseSelectDate: 'Select date',
    uploadDoc: 'Upload Document',
    dataValidate: 'Data Validate',
    importData: 'Import Data',
    complete: 'Complete',
    templateHeaderTip: 'Template header names and purchase order info cannot be changed, header row cannot be deleted',
    selectFileToImport: 'Select file to import and start',
    dataValidating: 'Data validating, please wait',
    dataRetrieveComplete: 'Data retrieve complete, total ',
    orderInfoCount: ' order(s)',
    errorInfoCount: 'Error info: ',
    correctAndRetry: ' item(s), please correct and retry',
    errorDetailDownload: 'Error details available in download',
    errorInfoXls: 'Error info.xls',
    importingDataTip: 'Importing data, page can be closed, system will complete import automatically.',
    importComplete: 'Import complete',
    confirmImport: 'Confirm Import',
    dragFileTip: 'Drag file here or ',
    clickUpload: 'click to upload',
    upload: 'Upload',
    confirmCancelLading: 'Confirm cancel lading?',
    confirmCancelTransferOrder: 'Confirm cancel transfer order?',
    reviewTransferOrder: 'Review Transfer Order',
    transferOrderNo: 'Transfer Order No.',
    transferOutInfo: 'Transfer Out Info',
    transferInInfo: 'Transfer In Info',
    transferOutAgent: 'Transfer Out Agent',
    transferOutAgentName: 'Transfer Out Agent Name',
    transferOutWarehouse: 'Transfer Out Warehouse',
    transferInAgent: 'Transfer In Agent',
    transferInAgentName: 'Transfer In Agent Name',
    transferInWarehouse: 'Transfer In Warehouse',
    productInfo: 'Product Info',
    transferNum: 'Transfer Qty',
    reject: 'Reject',
    agree: 'Agree',
    allocationForecast: 'Allocation Forecast',
    viewDetail: 'View Detail',
    ladingNo: 'Lading No.',
    pleaseEnterLadingNo: 'Enter lading no.',
    jdProductName: 'JD Product Name',
    pleaseEnterJdProductName: 'Enter JD product name',
    sendStatus: 'Ship Status',
    pleaseSelectSendStatus: 'Select ship status',
    sendTime: 'Ship Time',
    shipWarehouse: 'Ship Warehouse',
    pleaseSelectShipWarehouse: 'Select ship warehouse',
    relatedOrder: 'Related Order',
    pleaseEnterRelatedOrder: 'Enter related order',
    wayBillNo: 'Way Bill No.',
    pleaseEnterWayBillNo: 'Enter way bill no.',
    shipRegionAgentName: 'Ship Region Agent Name',
    pleaseSelectShipRegionAgentName: 'Select ship region agent name',
    waitSendNum: 'Wait Send Qty',
    provinceCityDistrict: 'Province/City/District',
    receiverAddress: 'Receiver Address',
    sendNum: 'Shipped Qty',
    logisticsNo: 'Logistics No.',
    tkOrderNo: 'Transfer Order No.',
    pleaseEnterTkOrderNo: 'Enter transfer order no.',
    targetWarehouse: 'Target Warehouse',
    pleaseEnterTargetWarehouse: 'Enter target warehouse',
    warehouseTransferStatus: 'Warehouse Transfer Status',
    pleaseSelectWarehouseTransferStatus: 'Select status',
    relatedTransferOrder: 'Related Transfer Order',
    pleaseEnterRelatedTransferOrder: 'Enter related transfer order',
    cloudWarehouseTransferNo: 'Cloud Warehouse Transfer No.',
    pleaseEnterCloudWarehouseTransferNo: 'Enter cloud warehouse transfer no.',
    transferInAgentId: 'Transfer In Agent ID',
    transferInAgentName: 'Transfer In Agent Name',
    transferOutAgentId: 'Transfer Out Agent ID',
    transferOutAgentName: 'Transfer Out Agent Name',
    tkNum: 'Transfer Qty',
    tkNumSent: 'Transferred Qty',
    productType: 'Product Type',
    pleaseSelectProductType: 'Select product type',
    allocationType: 'Allocation Type',
    pleaseSelectAllocationType: 'Select allocation type',
    pendingOrderAllocation: 'Pending Order Allocation',
    orderWeightAllocation: 'Order Weight Allocation',
    allocationNum: 'Allocation Qty',
    allocationTypeCol: 'Allocation Type',
    outOfStockNum: 'Out of Stock Qty',
    availableStock: 'Available Stock',
    systemWeight: 'System Weight %',
    systemAllocation: 'System Allocation',
    manualAllocation: 'Manual Allocation',
    saleShipmentExport: 'Sale Shipment Export',
    allocationListExport: 'Allocation List Export',
    warehouseOutDetailExport: 'Warehouse Out Detail Export',
    warehouseInDetailExport: 'Warehouse In Detail Export',
    productionStockExport: 'Production Stock Export',
    pleaseEnterRelationNo: 'Enter relation no.',
    pleaseSelectStockType: 'Select stock type',
    pleaseSelectStockGoods: 'Select stock goods',
    pleaseSelectStockWarehouse: 'Select stock warehouse',
    pleaseSelectStockNum: 'Select stock qty',
    pleaseSelectStockTime: 'Select stock time',
    createSuccess: 'Created successfully',
    addStockTitle: 'Add Stock Order',
    editStockTitle: 'Edit Stock Order',
    importDataErrorTitle: 'Warning: Data errors remain',
    importDataErrorContent: 'Some data has errors. If you confirm import, erroneous data will not be imported into the system.',
    jdTransferOrderExport: 'JD Transfer Order Export',
    audit: 'Audit',
    pendingAudit: 'Pending Audit',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
    audited: 'Audited',
    statusNew: 'New',
    statusInitial: 'Initial',
    statusComplete: 'Complete',
    statusCancelSuccess: 'Cancel Success',
    statusGenFailed: 'Gen Failed',
    confirmCancelStockIn: 'Confirm cancel stock in?',
    vendorName: 'Vendor',
    pleaseEnterVendorName: 'Enter vendor',
    stockInStatusInvalid: 'Invalid',
    stockInStatusIn: 'Stock In',
    stockInStatusOut: 'Stock Out',
    snCodePlaceholder: 'Enter SN code',
    // Auto Order Config
    addProductRatio: 'Add Product Ratio',
    autoOrderConfigTitle: 'Auto Order Commodity Ratio Maintenance',
    agentIdLabel: 'Agent ID:',
    ratioTip: '*Please maintain model ratios accurately. Auto orders will allocate amounts based on these ratios! Total ratio must equal 100%.',
    productModel: 'Model Name',
    ratioWithTotal: 'Ratio (Total {n}%)',
    pleaseEnterRatio: 'Enter ratio',
    updateLog: 'Update Log:',
    ratioValidationError: 'Please enter valid ratio: integer 1-100, total must equal 100%',
    autoOrderSaveSuccess: 'Save successful',
    autoOrderSaveFailed: 'Save failed',
    agentIdCol: 'Agent ID',
    agentNameCol: 'Agent Name',
    productModelCol: 'Model Name',
    productStatusCol: 'Product Status',
    productRatioCol: 'Product Ratio (Total=100)',
    lastUpdateTime: 'Last Update Time',
    lastUpdateBy: 'Last Updated By',
    createByCol: 'Created By',
    edit: 'Edit',
    detail: 'Detail',
    onlyXlsXlsx: 'Only .xls and .xlsx formats supported',
    noValidUploadData: 'No valid data to upload',
    createFailed: 'Create failed',
    modifyFailed: 'Modify failed',
    auditSuccess: 'Audit successful',
    rejectSuccess: 'Reject successful',
    auditFailed: 'Audit failed',
    rejectFailed: 'Reject failed',
    // Distribution
    warehouse: 'Warehouse',
    pleaseSelectWarehouseForAllocation: 'Select warehouse',
    timeLabel: 'Time',
    suggestSufficientStock: 'Recommended when stock is sufficient',
    allocate: 'Allocate',
    saveData: 'Save Data',
    confirmSavePreallocation: 'Save this pre-allocation data?',
    warehouseName: 'Warehouse Name',
    currentPendingOrder: 'Current Pending Orders',
    allocationSendGoodsNum: 'Allocated Pending Orders',
    productOrderNum: 'Product Order Qty'
  }
}
